<div class="loading-overlay">
    <div class="mat-spinner">
        <mat-spinner></mat-spinner>
    </div>
    <div class="text">{{ text | translate }}</div>
</div>